const cardFooterStyles = {
  display: "flex",
  flexDirection: "column",
  zIndex: 2
};
export {
  cardFooterStyles
};
